import { render, staticRenderFns } from "./FormularioNavidad.vue?vue&type=template&id=da8d9264&scoped=true&"
import script from "./FormularioNavidad.vue?vue&type=script&lang=ts&"
export * from "./FormularioNavidad.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioNavidad.vue?vue&type=style&index=0&id=da8d9264&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8d9264",
  null
  
)

export default component.exports